"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_router_dom_1 = require("react-router-dom");
const RedirectDefaultPath = ({ from, to }) => {
    const { pathname } = (0, react_router_dom_1.useLocation)();
    if (from instanceof Array) {
        const samePath = from.find(xFrom => xFrom === pathname);
        if (samePath)
            return (0, jsx_runtime_1.jsx)(react_router_dom_1.Navigate, { to: to, replace: true });
        return null;
    }
    if (pathname === from)
        return (0, jsx_runtime_1.jsx)(react_router_dom_1.Navigate, { to: to, replace: true });
    return null;
};
exports.default = RedirectDefaultPath;
